import { createFileRoute } from "@tanstack/react-router";
import { comparisonRoute } from "@/lib/seo/comparisonRoute";
import { getComparison } from "@/lib/seo/comparisons";

export const Route = createFileRoute("/jamfor/kunskapsoverforing-vs-process-dokumentation")(
  comparisonRoute(getComparison("kunskapsoverforing-vs-process-dokumentation")),
);
